module.exports = __webpack_public_path__ + "img/spc-navbar-desktop.f1886a5.png";